import { render, staticRenderFns } from "./OrderListNoRedis.vue?vue&type=template&id=1ca3cf07&scoped=true"
import script from "./OrderListNoRedis.vue?vue&type=script&lang=js"
export * from "./OrderListNoRedis.vue?vue&type=script&lang=js"
import style0 from "./OrderListNoRedis.vue?vue&type=style&index=0&id=1ca3cf07&prod&scoped=true&lang=css"
import style1 from "./OrderListNoRedis.vue?vue&type=style&index=1&id=1ca3cf07&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca3cf07",
  null
  
)

export default component.exports